module.exports = __webpack_public_path__ + "img/LoadBalancers.4b40924 1.6684b52.svg";